import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  IconButton,
  Popover,
  Tooltip,
  Typography,
} from '@material-ui/core';
import HelpIcon from '@material-ui/icons/Help';

export function InfoHeatMapPopover() {
  const [infoTarget, setInfoTarget] = React.useState(null);
  const { t } = useTranslation();

  function onClickInfo(event) {
    setInfoTarget(event.currentTarget);
  }

  function onCloseInfo() {
    setInfoTarget(null);
  }

  return (
    <>
      <Tooltip title={ (t && typeof t === 'function') ? (t('sidebar.heatmap.tooltip') || 'Información mapa de calor') : 'Información mapa de calor' }>
        <IconButton onClick={onClickInfo}>
          <HelpIcon style={{ color: '#7786fc' }} />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={infoTarget}
        open={Boolean(infoTarget)}
        onClose={onCloseInfo}
        PaperProps={{
          style: { width: 350, backgroundColor: 'rgba(70, 70, 70, .9)' },
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <>
          <Box padding={2}>
            <Typography
              variant="body1"
              style={{ color: 'white', fontWeight: 'bold' }}
            >
              { (t && typeof t === 'function') ? (t('heatmap.popover.title1') || 'Mapa de calor - disponibilidad por fecha') : 'Mapa de calor - disponibilidad por fecha' }
            </Typography>
            <Typography variant="body2" style={{ color: 'white' }}>
              { (t && typeof t === 'function') ? (t('heatmap.popover.text1') || 'El cálculo del indicador Uptime se obtiene de la suma de los valores uptime, mantenimiento y parcial del monitoreo durante la hora indicada.') : 'El cálculo del indicador Uptime se obtiene de la suma de los valores uptime, mantenimiento y parcial del monitoreo durante la hora indicada.' }
            </Typography>
            <Typography variant="body2" style={{ color: 'white' }}>
              { (t && typeof t === 'function') ? (t('heatmap.popover.text2') || 'El indicador Downtime solo considera el valor downtime del monitoreo.') : 'El indicador Downtime solo considera el valor downtime del monitoreo.' }
            </Typography>
          </Box>
          <Box padding={2} paddingTop={0}>
            <Typography
              variant="body1"
              style={{ color: 'white', fontWeight: 'bold' }}
            >
              { (t && typeof t === 'function') ? (t('heatmap.popover.title2') || 'Mapa de calor - disponibilidad por día de la semana') : 'Mapa de calor - disponibilidad por día de la semana' }
            </Typography>
            <Typography variant="body2" style={{ color: 'white' }}>
              { (t && typeof t === 'function') ? (t('heatmap.popover.text3') || 'Se promedian los indicadores agrupados por día de la semana. Cuando el indicador no tiene monitoreo se suma 0 para la obtención del promedio.') : 'Se promedian los indicadores agrupados por día de la semana. Cuando el indicador no tiene monitoreo se suma 0 para la obtención del promedio.' }
            </Typography>
          </Box>
          <Box padding={2} paddingTop={0}>
            <Typography variant="body2" style={{ color: 'white' }}>
              { (t && typeof t === 'function') ? (t('heatmap.popover.text4') || 'El indicador "S/M" se mostrará en periodos sin monitoreo.') : 'El indicador "S/M" se mostrará en periodos sin monitoreo.' }
            </Typography>
          </Box>
        </>
      </Popover>
    </>
  );
}
